<ng-template [cdkPortalOutlet]="selectedPortal"
             (attached)="onComponentAttachedToPortal($event)">
</ng-template>
